import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import DocsLayout from './layout/DocsLayout';
import { useAppSelector } from 'store/store';
import { languageSelector } from 'store/slices/languageSlice';
import { getDocumentContent } from 'api/documentation';

export enum PageNameType {
  AgentSkill = 'agent_skill',
  Changelog = 'change_log',
  DocToJson = 'doc_extract',
  Limits = 'limits',
  Overview = 'overview',
  Pricing = 'pricing',
  Quickstart = 'quickstart',
  TermsAndPolicies = 'terms_and_policies',
  EULA = 'EULA',
  UseCases = 'use_cases'
}

const Documentation = () => {
  const lang = useAppSelector(languageSelector);
  const [searchParams, setSearchParams] = useSearchParams();
  const docType = searchParams.get('docType');

  useEffect(() => {
    if (!docType) {
      setSearchParams({
        docType: 'overview'
      });
    }
  }, []);

  const {
    data: pageConents,
    isLoading,
    isError
  } = useQuery({
    queryKey: ['api-key-list', docType],
    queryFn: () => getDocumentContent(docType as PageNameType),
    select: (data) => {
      return data[lang];
    },
    enabled: !!docType
  });

  if (isLoading) {
    return <div>로딩중</div>;
  }

  if (isError) {
    return <div>에러 발생</div>;
  }

  return <DocsLayout content={pageConents} />;
};

export default Documentation;
